import { useVHTypeConfig } from '@vh/components/vh-types/vhTypeHooks';
import {
  conversationScoreSelector,
  sessionReportSelector,
} from '@vh/slices/chat/ChatSlice';
import { usePrevious } from '@vh/utility/StateHooks';
import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';

// used for emitting 'onVHScoreAvailable' - which is used to inform SCORM in the parent window
export const useVHScoreAvailableEmitter = () => {
  const { usesSessionReportAsScore } = useVHTypeConfig();
  const submitScore = useCallback((score) => {
    const event = new CustomEvent('onVHScoreAvailable', {
      detail: {
        score,
      },
    });
    window.parent?.document?.dispatchEvent(event);
  }, []);

  // handle pre vh 3.0 submissions
  const conversationScore = useSelector(conversationScoreSelector);
  const prevConversationScore = usePrevious(conversationScore);
  useEffect(() => {
    if (
      !usesSessionReportAsScore &&
      typeof conversationScore === 'number' &&
      prevConversationScore !== conversationScore
    ) {
      submitScore(conversationScore);
    }
  }, [
    submitScore,
    usesSessionReportAsScore,
    conversationScore,
    prevConversationScore,
  ]);

  // handle vh 3.0 submissions
  const sessionReport = useSelector(sessionReportSelector);
  const prevReport = usePrevious(sessionReport);
  useEffect(() => {
    if (
      usesSessionReportAsScore &&
      typeof sessionReport?.score !== 'undefined' &&
      sessionReport?.score !== null &&
      prevReport?.score !== sessionReport?.score
    ) {
      submitScore(sessionReport?.score);
    }
  }, [
    conversationScore,
    prevReport?.score,
    sessionReport?.score,
    submitScore,
    usesSessionReportAsScore,
  ]);
};
